import React, { useState } from 'react';
import { Search, Plus, Pencil, Trash2 } from 'lucide-react';
import { Input } from '../../ui/input';
import { Button } from '../../ui/button';

const InventoryTab = ({ 
  inventory, 
  searchQuery, 
  setSearchQuery, 
  onOpenAddProduct, 
  onOpenEditModal, 
  onUpdateStock, 
  onDeleteProduct 
}) => {
  const filteredProducts = inventory?.all_products?.filter(product =>
    product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    product.sku.toLowerCase().includes(searchQuery.toLowerCase())
  ) || [];

  return (
    <div data-testid="inventory-tab">
      <div className="flex flex-col sm:flex-row gap-4 mb-6">
        <div className="relative flex-1 max-w-md">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-text-muted" />
          <Input
            type="text"
            placeholder="Search products..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-12 rounded-full"
            data-testid="product-search"
          />
        </div>
        <Button
          onClick={onOpenAddProduct}
          className="rounded-full bg-forest hover:bg-forest-dark text-white"
          data-testid="add-product-btn"
        >
          <Plus className="w-4 h-4 mr-2" />
          Add New Product
        </Button>
      </div>

      <div className="bg-white rounded-2xl shadow-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-sand">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-medium text-text-muted uppercase">Product</th>
                <th className="px-6 py-4 text-left text-xs font-medium text-text-muted uppercase">SKU</th>
                <th className="px-6 py-4 text-left text-xs font-medium text-text-muted uppercase">Category</th>
                <th className="px-6 py-4 text-left text-xs font-medium text-text-muted uppercase">Price</th>
                <th className="px-6 py-4 text-left text-xs font-medium text-text-muted uppercase">Stock</th>
                <th className="px-6 py-4 text-right text-xs font-medium text-text-muted uppercase">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-stone-100">
              {filteredProducts.map((product) => (
                <tr key={product.id} className="hover:bg-sand/30" data-testid={`product-row-${product.id}`}>
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-3">
                      <img src={product.image_url} alt={product.name} className="w-10 h-10 rounded-lg object-cover" />
                      <span className="font-medium text-text-primary">{product.name}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-text-secondary">{product.sku}</td>
                  <td className="px-6 py-4 text-text-secondary capitalize">{product.category}</td>
                  <td className="px-6 py-4 text-terracotta font-medium">${product.price?.toFixed(2)}</td>
                  <td className="px-6 py-4">
                    <Input
                      type="number"
                      value={product.quantity_in_stock}
                      onChange={(e) => onUpdateStock(product.id, e.target.value)}
                      className="w-20 h-8 text-center rounded-lg"
                      min="0"
                      data-testid={`stock-input-${product.id}`}
                    />
                  </td>
                  <td className="px-6 py-4 text-right">
                    <div className="flex items-center justify-end gap-2">
                      <button 
                        onClick={() => onOpenEditModal(product)} 
                        className="p-2 hover:bg-sand rounded-lg"
                        data-testid={`edit-btn-${product.id}`}
                      >
                        <Pencil className="w-4 h-4 text-text-muted" />
                      </button>
                      <button 
                        onClick={() => onDeleteProduct(product.id, product.name)} 
                        className="p-2 hover:bg-red-50 rounded-lg"
                        data-testid={`delete-btn-${product.id}`}
                      >
                        <Trash2 className="w-4 h-4 text-red-500" />
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        
        {filteredProducts.length === 0 && (
          <div className="text-center py-12 text-text-muted">
            No products found
          </div>
        )}
      </div>
    </div>
  );
};

export default InventoryTab;
